module.exports = __webpack_public_path__ + "static/media/cross.64398169.svg";